// Ciclo de vida de una sesion de firma. Viaja como NUMERO.
//
// La regla de "completa" vive en el BACKEND: se pinta el `status` que llega y NO se recalcula
// sumando las resoluciones de los items. `rejected`, `expired` y `consumed` son terminales: con
// cualquiera de ellos hay que abrir una sesion nueva.
export enum ContractSignatureSessionStatus {
    pending = 1,
    completed = 2,
    rejected = 3,
    expired = 4,
    consumed = 5
}
